import {
  Autocomplete,
  Button,
  CircularProgress,
  FormControl,
  TextField,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { fieldTemplateService } from '../../../services/fieldTemplateService'
import { GroupHeader, GroupItems, textFieldStyle } from './CreateProcessTemplateDialog'
import { processTemplateService } from '../../../services/processTemplateService'
import { listDataService } from '../../../services/listDataService'
import { FIELD_TYPES, PROTECTED_LIST_TYPES } from '../../../utility/constants'
import { toast } from 'react-toastify'

const defaultVale = {
  id: null,
  list_id: 18,
  list_type: 'process-reference',
  identifier_field_template_id: null,
}

const ProtectedFieldSettingUI = ({ processTemplate, setSelectedProcess, setShow }) => {
  const { user } = useAuthContext()
  const [fields, setFields] = useState([])
  const [lists, setLists] = useState([])
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({ ...defaultVale })

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      if (processTemplate?.id) {
        const allFields = await fieldTemplateService.getDerivableFieldsForProcess(
          user,
          processTemplate?.id,
        )
        console.log('allFields', allFields)
        setFields(allFields)

        const lists = await listDataService.getListOfListsForAdmin(user)
        setLists(lists)
        console.log('lists', lists)

        const protectedList = await processTemplateService.getProtectedList(
          user,
          processTemplate?.id,
        )
        setData(protectedList)
      }
      setLoading(false)
    })()
  }, [])

  const onSave = async () => {
    try {
      // apply data validation
      if (!data.identifier_field_template_id || !data.list_id || !data.list_type) {
        throw new Error('All fields are mandatory.')
      }

      await processTemplateService.addEditProtectedList(user, data)
      toast.success('Exporting And Linking Identifier setup done.')
    } catch (error) {
      toast.error(error.message)
    }
  }

  if (loading) {
    return (
      <div
        style={{
          height: '40vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress color="primary" size={40} />
      </div>
    )
  }

  return (
    <div>
      <Typography>Process Data Exporting and Linking </Typography>

      {!data.identifier_field_template_id && (
        <Typography fontSize={'11px'} variant="caption" color={'GrayText'}>
          By default, it will be stored in the protected list with the value :
          "process-prefix"-"process_reference_num".
        </Typography>
      )}
      <FormControl
        variant="outlined"
        fullWidth
        size="small"
        color="primary"
        style={{ marginTop: 16 }}
      >
        <Autocomplete
          id="select-derived-field"
          options={fields
            .filter((it) => it.data_structure != FIELD_TYPES.TABLE && !it.is_subfield)
            .sort((a, b) => -b.activity_template_name.localeCompare(a.activity_template_name))}
          groupBy={(option) => option?.activity_template_name}
          size="small"
          getOptionLabel={(item) => item?.field_template_name}
          value={fields.find((it) => it.id == data?.identifier_field_template_id) || null}
          onChange={(_, newValue) => {
            setData({
              ...data,
              identifier_field_template_id: newValue.id,
            })
          }}
          renderGroup={(params) => (
            <li key={params.key}>
              <GroupHeader>{params.group}</GroupHeader>
              <GroupItems>{params.children}</GroupItems>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Select Process Identifier Field"
              color="primary"
            />
          )}
          sx={textFieldStyle}
        />
      </FormControl>
      <FormControl
        variant="outlined"
        fullWidth
        size="small"
        color="primary"
        style={{ marginTop: 16 }}
      >
        <Autocomplete
          size="small"
          options={lists || []}
          value={lists.find((it) => it.id == data.list_id) || null}
          getOptionLabel={(option) => option.list_name}
          label="Select List"
          onChange={(_, v) =>
            setData({
              ...data,
              list_id: v?.id || null,
            })
          }
          renderInput={(params) => {
            return <TextField {...params} label="Select List" />
          }}
          sx={textFieldStyle}
        />
      </FormControl>
      <FormControl
        key={data.list_type || 'list_type'}
        variant="outlined"
        fullWidth
        size="small"
        color="primary"
        style={{ marginTop: 16 }}
      >
        <Autocomplete
          size="small"
          options={Object.entries(PROTECTED_LIST_TYPES).map(([key, value]) => {
            return { label: value, value: value }
          })}
          value={data.list_type}
          label="Select List Type"
          onChange={(_, v) =>
            setData({
              ...data,
              list_type: v.value,
            })
          }
          renderInput={(params) => {
            return <TextField {...params} label="Select List Type" />
          }}
          sx={textFieldStyle}
        />
      </FormControl>
      <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end', columnGap: 16 }}>
        <Button
          variant="outlined"
          onClick={() => {
            setSelectedProcess(null)
            setShow(false)
          }}
        >
          Cancel
        </Button>
        <Button color="primary" variant="contained" onClick={onSave}>
          Save
        </Button>
      </div>
    </div>
  )
}

export default ProtectedFieldSettingUI
